// extracted by mini-css-extract-plugin
export default {"container":"cd_d","reversed":"cd_jF","textBlock":"cd_gh","title":"cd_c0","secondary":"cd_gZ","description":"cd_cM","button":"cd_dS","containerWithCards":"cd_jG"};